import { trackError } from 'helpers/track_error';
import type { AccountantLeadPayload, PartnerQuestionKeys } from '../components/types';

export function trackQuestionAnswered(
  questionKey: PartnerQuestionKeys,
  answer: string,
  surveySource?: string
) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'PartnerSignupSurveyQuestionAnswered',
    data: {
      questionKey,
      answer,
      survey_source: surveySource,
    },
  });
}

export function trackPartnerSurveySignupSubmitFailed(
  accountantLead: AccountantLeadPayload,
  status: string,
  responseText: string
) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AccountantLeadCreationEvent',
    data: {
      eventType: 'submit',
      result: 'failure',
      location: 'Partner Signup v2',
      accountantLead,
      failureStatus: status,
      failureReason: responseText,
    },
  });

  trackError({
    error: new Error(`[PartnerSurveySignup] Failed with status ${status}`),
    custom: {
      message: responseText,
    },
  });
}

export function trackPartnerSurveySignupSubmitSuccess() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AccountantLeadCreationEvent',
    data: {
      eventType: 'submit',
      result: 'success',
      location: 'Partner Signup v2',
    },
  });
}
